<ion-header class="ion-no-border" [translucent]="true">

  <ion-toolbar color="light">
    <ion-buttons *ngIf="!fromMenu" slot="start">
      <ion-back-button slot="start"></ion-back-button>
    </ion-buttons>
    
    <ion-title style="display: flex;flex-direction: column; line-height: 1.1rem;">
      <small>I tuoi dati su</small>
      <div>{{group.name}}</div>
    </ion-title>

    <ion-buttons *ngIf="fromMenu" slot="end">
      <ion-button (click)="modalController.dismiss()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div style="background-color: var(--ion-color-light); padding:16px">
    <p-message icon="pi pi-info-circle" severity="warn">Per accedere a questo canale sono richiesti alcuni
      dati</p-message>
    <!-- <p 
    style="background-color: gainsboro; padding: 8px; border-radius: 8px; display: flex; align-items: center; margin: 16px;">
    <ion-icon style="font-size: 48px; margin-right: 8px;" color="dark" slot="end"
      name="information-circle-outline"></ion-icon>
    Per accedere a questo canale sono richiesti alcuni dati
  </p> -->

  </div>


  <div *ngFor="let gf of groupFields">
    <ion-item color="white" lines="none">
      <ion-input [disabled]="gf.inherit ? gf.inherit : false" *ngIf="gf.type == 0" [(ngModel)]="gf.value" (ionInput)="checkValidField(gf)"
        autocapitalize="sentences" [label]="gf.label" labelPlacement="floating"></ion-input>

      <ion-input inputmode="numeric" [debounce]="300" (ionFocus)="gf.focus = true" (ionBlur)="gf.focus = false" [disabled]="gf.inherit ? gf.inherit : false" *ngIf="gf.type == 4" [(ngModel)]="gf.value" (ionInput)="checkCapIt(gf)"
        autocapitalize="sentences" [label]="gf.label" labelPlacement="floating"></ion-input>

      <ion-input [disabled]="gf.inherit ? gf.inherit : false" (ionFocus)="gf.focus = true" (ionBlur)="gf.focus = false" *ngIf="gf.type == 1"
        inputmode="numeric" [(ngModel)]="gf.value" (ionInput)="checkDateField(gf)" [label]="gf.label"
        labelPlacement="floating" placeholder="Formato DD/MM/YYYY">
      </ion-input>

      <ion-input [disabled]="gf.inherit ? gf.inherit : false" (ionFocus)="gf.focus = true" (ionBlur)="gf.focus = false" *ngIf="gf.type == 5"
        inputmode="numeric" [(ngModel)]="gf.value" (ionInput)="checkValidYear(gf)" [label]="gf.label"
        labelPlacement="floating" placeholder="Formato YYYY">
      </ion-input>

      <ion-input [disabled]="gf.inherit ? gf.inherit : false" *ngIf="gf.type == 2" [(ngModel)]="gf.value" [debounce]="300"
        (ionInput)="checkFiscalCode(gf)" type="text" autocapitalize="characters" [label]="gf.label"
        labelPlacement="floating"></ion-input>

      <ion-input [disabled]="gf.inherit ? gf.inherit : false" *ngIf="gf.type == 3" [(ngModel)]="gf.value" (ionInput)="checkFNOMCEOInput(gf)"
        type="number" inputmode="numeric" [label]="gf.label" labelPlacement="floating"></ion-input>

      <ion-input [disabled]="gf.inherit ? gf.inherit : false" (ionFocus)="gf.focus = true" (ionBlur)="gf.focus = false" *ngIf="gf.type == 7"
        inputmode="numeric" [(ngModel)]="gf.value" (ionInput)="checkMinimumAgeDate(gf)" [label]="gf.label"
        labelPlacement="floating" placeholder="Formato GG-MM-YYYY">
      </ion-input>


      <ion-select [disabled]="gf.inherit ? gf.inherit : false" *ngIf="gf.type == 6" [(ngModel)]="gf.value" interface="popover"
         [placeholder]="gf.label" (ionFocus)="checkValidGender(gf)">
         <ion-select-option value="Femmina">Femmina</ion-select-option>
         <ion-select-option value="Maschio">Maschio</ion-select-option>
         <ion-select-option value="Altro">Altro</ion-select-option>
      </ion-select>


      <ion-note [color]="gf.required ? 'danger' : 'dark'" slot="end">{{gf.required ? "obbligatorio" : "facoltativo"
        }}</ion-note>
      <!-- <ion-icon style="margin-left: 8px;" *ngIf="!gf.valid && gf.required" slot="end" color="danger"
          name="alert-circle"></ion-icon> -->
      <!-- <ion-icon style="margin-left: 8px;" *ngIf="gf.valid" slot="end" color="success"
          name="checkmark-circle"></ion-icon> -->


    </ion-item>
    <div *ngIf="gf.focus && !gf.valid && gf.error" style="padding: 2px 16px;">
      <p-message severity="error" icon="pi pi-info-circle">{{gf.error}}</p-message>
    </div>


  </div>

</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar color="light">
    <ion-spinner slot="start" *ngIf="saving"></ion-spinner>
    <ion-button style="margin-right: 16px;" slot="end" [disabled]="saving || !formIsValid()"
      (click)="updatePrivacy()">Continua</ion-button>
  </ion-toolbar>
</ion-footer>
